import React from 'react';
import { StarIcon, MapPinIcon, XCircleIcon } from 'lucide-react';
import { Section, FadeIn } from './Shared';
export const TestimonialCard = ({
  quote,
  name,
  location,
  role
}: {
  quote: string;
  name: string;
  location: string;
  role: string;
}) => <div className="bg-white p-4 md:p-8 rounded-xl md:rounded-2xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-319">
    <div className="flex text-gold mb-2 md:mb-4" data-id="element-320">
      {[...Array(5)].map((_, i) => <StarIcon key={i} fill="currentColor" size={16} data-id="element-321" />)}
    </div>
    <p className="text-gray-700 italic mb-4 md:mb-6 flex-grow text-sm md:text-base" data-id="element-322">
      "{quote}"
    </p>
    <div className="mt-auto" data-id="element-323">
      <p className="font-bold text-charcoal text-sm md:text-base" data-id="element-324">{name}</p>
      <div className="flex items-center text-xs md:text-sm text-gray-500 mb-1" data-id="element-325">
        <MapPinIcon size={12} className="mr-1 text-coral" data-id="element-326" /> {location}
      </div>
      <p className="text-xs md:text-sm text-rosegold font-semibold" data-id="element-327">{role}</p>
    </div>
  </div>;
export const SocialProof = () => {
  const testimonials = [{
    quote: 'Organicé todas mis clases GAP en una tarde. Ahora tengo cada sesión pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
    role: 'Instructora de GAP en Estudio Propio'
  }, {
    quote: 'Las clases con progresión real por nivel cambiaron todo. Mis alumnas mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'Instructora en Centro de Adultos Mayores'
  }, {
    quote: 'Adapto el mismo ejercicio de glúteos a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
    name: 'Valentina F.',
    location: 'Córdoba',
    role: 'Instructora de GAP Grupal e Individual'
  }];
  const painPoints = ['Llegás a la clase sin saber exactamente qué ejercicio GAP vas a dar hoy', 'Tus alumnas no progresan porque no tenés una secuencia clara de glúteos, abdomen y piernas', 'El 40% de las alumnas abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 o 15 ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnas de distintos niveles juntas y la clase GAP se convierte en un caos', 'Fin de mes y las alumnas se van sin avisar porque no ven resultados concretos'];
  return <>
      <Section bg="white" data-id="element-328">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-329">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.2} data-id="element-330">
              <TestimonialCard {...t} data-id="element-331" />
            </FadeIn>)}
        </div>
      </Section>

      <Section bg="charcoal" data-id="element-332">
        <FadeIn data-id="element-333">
          <div className="max-w-4xl mx-auto" data-id="element-334">
            <h2 className="text-2xl md:text-4xl font-bold text-center mb-6 md:mb-12 text-white" data-id="element-335">
              Si sos instructora de GAP en Argentina, esto te va a sonar..
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-336">
              {painPoints.map((point, i) => <div key={i} className="flex items-start space-x-3 bg-white/5 p-2.5 md:p-4 rounded-lg md:rounded-xl border border-white/10" data-id="element-337">
                  <XCircleIcon className="text-coral shrink-0 mt-0.5" size={18} data-id="element-338" />
                  <p className="text-gray-300 text-sm md:text-lg" data-id="element-339">{point}</p>
                </div>)}
            </div>

            <div className="mt-6 md:mt-16 text-center" data-id="element-340">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 md:mb-8" data-id="element-341">
                ¿Cuántas clases más vas a improvisar?
              </h3>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
};